import { makeResetStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  width: '100%',
  ...shorthands.overflow('hidden'),
  '& .card': {
    height: 'fit-content',
    ...shorthands.padding('16px', '16px', '32px', '16px'),
  },
  '& .button': {
    paddingLeft: '0px',
  },
  '& .placement-preview-text-wrapper': {
    marginTop: '8px',
    marginBottom: '8px',
  },
  '& .placement-preview-text': {
    display: 'flex',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    ...shorthands.padding('4px'),
    ...shorthands.gap('2px'),
    backgroundColor: tokens.colorNeutralBackground5,
    ...shorthands.borderRadius('4px'),
    width: 'fit-content',
  },
});

export const usePlacementEditStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  width: '100%',
  ...shorthands.overflow('hidden'),
  '& .card': {
    width: '340px',
    height: '100%',
    ...shorthands.borderRadius('8px'),
    ...shorthands.padding('16px', '16px', '32px', '16px'),
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
  },
  '& .card-header': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '308px',
  },
  '& .back-button': {
    paddingLeft: '0px',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 600,
    '& .ratio-text': {
      maxWidth: '203px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ...shorthands.overflow('hidden'),
    },
  },
  '& .action-button': {
    ...shorthands.border('1px', 'solid', 'rgba(209, 209, 209, 1)'),
    ...shorthands.borderRadius('4px'),
    ...shorthands.padding('6px', '12px'),
    marginLeft: '6px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: 'rgba(36, 36, 36, 1)',
    flexShrink: 0,
    minWidth: 0,
  },
  '& .placement-preview-text-wrapper': {
    marginBottom: '6px',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'rgba(36, 36, 36, 1)',
  },
  '& .image-preview-image-wrapper': {
    width: '100% !important',
    height: '100%',
  },
  '& .placement-preview-wrapper': {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '8px',
    width: '100%',
    height: '100%',
  },
});
